import { SerpJobApplicationProviderFilters } from '../../../providers/api/serp-job-applications/getSerpJobApplications';
import { FiltersMapper } from '../../../hooks/use-filters/useFilters';
import { GenericSerpSortOption } from '../../../types';
import { SerpJobApplicationAdvancedFilters } from '../../containers/filter-serp-job-applications-action/types';

export const FILTER_KEYS = [
  'toBeManaged',
  'inManagement',
  'assigned',
  'inProposal',
  'archived',
  'trashed',
  'pastInterviews',
  'futureInterviews',
  'all',
] as const;

export type JobApplicationSerpPageFilterKey = typeof FILTER_KEYS[number];

export const SORT_KEYS = [
  'default',
  'mostRecentCreation',
  'leastRecentCreation',
  'mostRecentUpdate',
  'leastRecentUpdate',
  'mostRecentInterview',
  'leastRecentInterview',
] as const;

export type JobApplicationSerpPageSortKey = typeof SORT_KEYS[number];

export type JobApplicationSerpSortOption = GenericSerpSortOption<JobApplicationSerpPageSortKey>;

export type JobApplicationSerpPageFilterOption = {
  key: JobApplicationSerpPageFilterKey,
  label: {
    short: string,
    long: string,
  },
  value: SerpJobApplicationProviderFilters,
};

export interface JobApplicationSerpPageFilterOptionCtx {
  userIsAgent: boolean,
  userIsHR: boolean,
  userIsAdmin: boolean,
}

export interface JobApplicationSerpPageFilters {
  q?: string,
  filter: JobApplicationSerpPageFilterKey,
  sort: JobApplicationSerpPageSortKey,
}

export type CombinedJobApplicationFilters = JobApplicationSerpPageFilters & SerpJobApplicationAdvancedFilters;
export type JobApplicationSerpPageFiltersMapper = FiltersMapper<JobApplicationSerpPageFilters>;
